module.exports = __webpack_public_path__ + "static/media/reserva_exitosa_yellow.4682972b.svg";